export function sum(arr, summer) {
  return arr.reduce((total, item) => {
    return (total += Number(summer(item)));
  }, 0);
}
